import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Role } from './role';
import { GeneralMethods } from 'src/app/globalClass/general-methods';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { TreeviewItem } from 'ngx-treeview';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  roleList: Role[];
  private routeApi = "SegRols";
  constructor(
    private _generalHttp:GeneralHttpService,
  ) { }

  postRole(formData: Role) {
    return this._generalHttp.postHttp(formData,this.routeApi);
  }

  updateRol(roleForm:any){
    return this._generalHttp.postHttp(roleForm,`${this.routeApi}/UpdateRol`)
  }

  getRoles(){
    return this._generalHttp.getHttp(`${this.routeApi}`);
  }

  getRoleById(idRol:number){
    return this._generalHttp.getHttpById(idRol,`${this.routeApi}`)
  }

  enableOrDisable(idRol:number){
    return this._generalHttp.getHttpById(idRol,`${this.routeApi}/EnableOrDisable`);
  }

  getModules(){
    return this._generalHttp.getHttp(`${this.routeApi}/GetModules`);
  }

  getModulesByRol(idRol:number){
    return this._generalHttp.getHttpById(idRol,`${this.routeApi}/GetModulesByRol`);
  }

  saveModules(form:any[]){
    return this._generalHttp.postHttp(form,`${this.routeApi}/SaveModule`)
  }

  typeUser(idUser:number){
    return this._generalHttp.getHttpById(idUser,`${this.routeApi}/TypeUser`)
  }
  
}


































































































































































































































































































